import gql from 'graphql-tag';

export default gql`
    mutation EditPermissionsToRole($input: [EditPermissionsToRoleInput]) {
        editPermissionsToRole(input: $input) {
            errors
        }
    }
`;
